// extracted by mini-css-extract-plugin
export default {"bed":"bed_option_bed__94qAp","roomTitle":"bed_option_roomTitle__58FOg","bedIcon":"bed_option_bedIcon__x-v0m"};